import {Component, signal, WritableSignal} from '@angular/core';

@Component({
  selector: 'braidsbook-hairdressers-list-skeleton',
  imports: [],
  templateUrl: './hairdressers-list-skeleton.component.html',
  styles: ``
})
export class HairdressersListSkeletonComponent {
  iterator: WritableSignal<number[]> = signal(Array.from({length: 12}, (_, i) => i));
}
